import { CryptoWallet } from "@models";
import { TYPE_NAME_LEVERAGED_TOKEN } from "@helpers/constants";

export class LeveragedTokenWallet extends CryptoWallet {
	public static TypeName = TYPE_NAME_LEVERAGED_TOKEN;
}
